export default __webpack_public_path__ + "static/media/car_right.72aafb8b.png";